import type { PropsWithChildren } from 'react';
import type { Meta, StoryFn } from '@storybook/react';
import type { RepeaterProps } from './Repeater';

import { Repeater } from './Repeater';

import { Container } from 'storyComponents/Container';

const codeString = '<Repeater flexDirection={flexDirection} gap={gap}>{children}</Repeater>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Repeater',
  component: Repeater,
  argTypes: {
    flexDirection: {
      control: {
        type: 'select',
      },
    },
    gap: {
      control: {
        type: 'select',
        sort: false,
      },
    },
    children: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Repeater,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<RepeaterProps>>;

const Template: StoryFn<PropsWithChildren<RepeaterProps>> = (args) => (
  <Container>
    <Repeater {...args} />
  </Container>
);

export const RepeaterExample = Template.bind({});
RepeaterExample.args = {
  flexDirection: 'column',
  gap: '050',
  children: (
    <>
      <div>Example item 1</div>
      <div>Example item 2</div>
      <div>Example item 3</div>
    </>
  ),
};
